import * as React from 'react';
import cx from 'classnames';
import { TypographyStyle, TypographyWeight, ThemeStyle } from '@treelab/panda';

import './typography.css';

const TAG_MAP = {
  [TypographyStyle.H1]: 'h1',
  [TypographyStyle.H2]: 'h2',
  [TypographyStyle.H3]: 'h3',
  [TypographyStyle.H4]: 'h4',
  [TypographyStyle.P1]: 'span',
  [TypographyStyle.P2]: 'span',
  [TypographyStyle.LABEL1]: 'label',
  [TypographyStyle.LABEL2]: 'label',
};

const TEXT_THEME = {
  [ThemeStyle.black]: 'panda-typography--theme-black',
  [ThemeStyle.gray]: 'panda-typography--theme-gray',
  [ThemeStyle.blue]: 'panda-typography--theme-blue',
  [ThemeStyle.white]: 'panda-typography--theme-white',
  [ThemeStyle.red]: 'panda-typography--theme-red',
};

export interface ITypography {
  /** Optional passed classname. */
  className?: string;
  /** Content specified as children. */
  children: React.ReactNode;
  /** Make text display block */
  isBlock?: boolean;
  /** Id */
  id?: string;
  /** Make text ellipsis, default is true */
  isTextEllipsis?: boolean;
  /** Passed inline styles */
  style?: object;
  /** Custom html Tag */
  tag?: string;
  /** Theme. User has option to use our default themes */
  theme?: ThemeStyle;
  /** Type option from set types */
  type?: TypographyStyle;
  /** Specified weight of typography */
  weight?: TypographyWeight;
}

export const Typography: React.FC<ITypography> = ({
  isBlock = false,
  isTextEllipsis = true,
  id,
  children,
  className,
  tag,
  theme = ThemeStyle.black,
  type = TypographyStyle.P1,
  style,
  weight,
}) => {
  const ElementTag = (tag || TAG_MAP[type]) as any;
  const combinedClass = cx({
    [`panda-typography--${type}`]: true,
    [`panda-typography--weight-${weight}`]: !!weight,
    'panda-typography--display-block': isBlock,
    'text-ellipsis': isTextEllipsis,
    [TEXT_THEME[theme]]: true,
    [className || '']: !!className,
  });

  return (
    <ElementTag id={id} className={combinedClass} style={style}>
      {children}
    </ElementTag>
  );
};
